export default [
  {
    name: '四平市',
    images: 'home/gis/gis-siping.png',
    areaCode: '2203',
    positions: [
      {
        left: '103',
        top: '83',
        width: '110',
        height: '65',
        images: 'home/gis/gis-lishu.png',
        name: '梨树县',
        url: 'lishuxian',
        mapWidth: '340',
        positions: [
          {
            top: '140',
            width: '35',
            height: '45',
            right: '30',
            name: '蔡家镇',
            url: 'caijiazhen'
          }
        ]
      },
      {
        name: '铁西区',
        url: 'tiexiqu',
        width: '30',
        height: '20',
        top: '170',
        left: '140',
        mapWidth: '340'
      }
    ],
    left: '90',
    top: '120',
    width: '40',
    height: '41',
    url: 'sipingshi'
  },
  {
    name: '吉林市',
    images: 'home/gis/gis-jilin.png',
    areaCode: '2202',
    mapWidth: '210',
    positions: [
      {
        width: '50',
        height: '40',
        top: 123,
        left: 103,
        name: '永吉县',
        areaCode: '220221',
        mapWidth: 290,
        url: 'yongjixian',
        images: 'home/gis/gis-yongji.png',
        positions: [
          {
            top: '20',
            left: '40',
            width: '43',
            height: '74',
            name: '万昌镇',
            url: 'wanchangzhen'
          },
          {
            width: 42,
            height: 74,
            top: 99,
            left: 50,
            name: '金家乡',
            url: 'jinjiaxiang'
          },
          {
            top: '173',
            left: '80',
            width: '63',
            height: '40',
            name: '黄榆乡',
            url: 'huangyuxiang'
          },
          {
            width: 57,
            height: 68,
            top: 185,
            left: 150,
            name: '双河镇',
            url: 'shuanghezhen'
          },
          {
            top: 85,
            left: 188,
            width: '55',
            height: '92',
            name: '西阳镇',
            url: 'xiyangzhen'
          },
          {
            top: '75',
            left: '251',
            width: '55',
            height: '76',
            name: '口前镇',
            url: 'kouqianzhen'
          },
          {
            top: 160,
            left: 236,
            width: '79',
            height: '104',
            name: '北大湖镇',
            url: 'beidahuzhen'
          },
          {
            top: '42',
            left: '136',
            width: '57',
            height: '55',
            name: '一拉溪镇',
            url: 'yilaxizhen'
          },
          {
            width: 47,
            height: 68,
            top: 50,
            left: 86,
            name: '岔路河镇',
            url: 'chaluhezhen'
          }
        ]
      },
      {
        width: 50,
        height: 20,
        top: 63,
        left: 93,
        areaCode: '220202',
        name: '昌邑区',
        url: 'changyiqu',
        mapWidth: 308,
        images: 'home/gis/gis-changyi.png'
      },
      {
        width: 30,
        height: 26,
        top: 89,
        left: 124,
        name: '船营区',
        areaCode: '220204',
        url: 'changyiqu'
      },
      {
        width: 28,
        height: 40,
        top: 114,
        left: 160,
        name: '丰满区',
        areaCode: '220211',
        url: 'fengmanqu',
        mapWidth: 260,
        images: 'home/gis/gis-fengman.png'
      }
    ],
    left: '178',
    top: '90',
    width: '50',
    height: '55',
    url: 'jilinshi'
  },
  {
    name: '松原市',
    images: 'home/gis/gis-songyuan.png',
    areaCode: '2207',
    positions: [
      {
        top: '90',
        left: '160',
        width: '70',
        height: '50',
        areaCode: '220721',
        mapWidth: 260,
        name: '前郭尔罗斯蒙古族自治县',
        url: 'qianguoxian',
        images: 'home/gis/gis-qianguoxian.png',
        positions: [
          {
            bottom: '50',
            left: '50',
            width: '40',
            height: '40',
            name: '乌兰敖都乡',
            url: 'wulanaodouxiang'
          },
          {
            bottom: '50',
            left: '100',
            width: '40',
            height: '40',
            name: '查干花镇',
            url: 'chaganhuazhen'
          },
          {
            bottom: '25',
            left: '110',
            width: '40',
            height: '20',
            name: '东三家子乡',
            url: 'dongsanjiazixiang'
          },
          {
            bottom: '10',
            left: '90',
            width: '40',
            height: '20',
            name: '浩特芒哈乡',
            url: 'haotemanghaxiang'
          },
          {
            bottom: '40',
            left: '145',
            width: '60',
            height: '30',
            name: '乌兰图嘎镇',
            url: 'wulantugazhen'
          },
          {
            bottom: '70',
            left: '145',
            width: '50',
            height: '30',
            name: '乌兰塔拉乡',
            url: 'wulantalaxiang'
          },
          {
            bottom: '80',
            left: '200',
            width: '40',
            height: '30',
            name: '长龙乡',
            url: 'zhanglongxiang'
          },
          {
            bottom: '100',
            left: '230',
            width: '40',
            height: '20',
            name: '洪泉乡',
            url: 'hongquanxiang'
          },
          {
            bottom: '100',
            left: '280',
            width: '20',
            height: '40',
            name: '哈拉毛都良种场',
            url: 'halamaodouliangzhongchang'
          },
          {
            bottom: '120',
            left: '260',
            width: '20',
            height: '40',
            name: '王府站镇',
            url: 'wangfuzhanzhen'
          },
          {
            bottom: '120',
            left: '230',
            width: '20',
            height: '30',
            name: '额如乡',
            url: 'eruxiang'
          },
          {
            width: 30,
            height: 25,
            bottom: 104,
            left: 170,
            name: '海渤日戈镇',
            url: 'haiborigezhen'
          },
          {
            bottom: '120',
            left: '200',
            width: '20',
            height: '25',
            name: '宝甸乡',
            url: 'baodianxiang'
          },
          {
            bottom: 145,
            left: 187,
            width: '40',
            height: '20',
            name: '套浩太乡',
            url: 'taohaotaixiang'
          },
          {
            width: 20,
            height: 20,
            bottom: 160,
            left: 223,
            name: '白依拉嘎乡',
            url: 'baiyilagaxiang'
          },
          {
            width: 40,
            height: 30,
            bottom: 160,
            left: 250,
            name: '吉拉吐乡',
            url: 'jilatuxiang'
          },
          {
            width: 20,
            height: 20,
            bottom: 180,
            left: 197,
            name: '达里巴乡',
            url: 'dalibaxiang'
          },
          {
            width: 20,
            height: 50,
            top: 20,
            left: 174,
            name: '长山镇',
            url: 'zhangshanzhen'
          },
          {
            width: 30,
            height: 20,
            top: 15,
            left: 195,
            name: '平凤乡',
            url: 'pingfengxiang'
          },
          {
            top: '20',
            left: '140',
            width: '30',
            height: '20',
            name: '八郎镇',
            url: 'balangzhen'
          },
          {
            width: 40,
            height: 15,
            top: 87,
            left: 159,
            name: '查干湖镇',
            url: 'chaganhuzhen'
          }
        ]
      },
      {
        bottom: '10',
        left: '80',
        width: '90',
        height: '50',
        name: '长岭县',
        areaCode: '220722',
        url: 'changlingxian',
        images: 'home/gis/gis-changling.png',
        positions: [
          {
            width: 40,
            height: 40,
            bottom: 80,
            left: 60,
            name: '大兴镇',
            url: 'daxingzhen'
          },
          {
            width: 40,
            height: 40,
            bottom: 95,
            left: 110,
            name: '前7号镇',
            url: 'daxingzhen'
          },
          {
            bottom: '50',
            left: '140',
            width: '40',
            height: '40',
            name: '新安镇',
            url: 'xinanzhen'
          },
          {
            width: 25,
            height: 40,
            bottom: 50,
            left: 185,
            name: '腰坨子乡',
            url: 'yaotuozixiang'
          },
          {
            width: 35,
            height: 15,
            bottom: 67,
            left: 209,
            name: '东岭乡',
            url: 'donglingxiang'
          },
          {
            width: 35,
            height: 15,
            bottom: 50,
            left: 231,
            name: '前进乡',
            url: 'qianjinxiang'
          },
          {
            width: 35,
            height: 15,
            bottom: 64,
            left: 270,
            name: '三县堡乡',
            url: 'sanxianbaoxiang'
          },
          {
            top: '20',
            left: '30',
            width: '94',
            height: '30',
            name: '三十号乡',
            url: 'sanshihaoxiang'
          },
          {
            width: 40,
            height: 40,
            top: 82,
            left: 13,
            name: '太平川镇',
            url: 'taipingchuanzhen'
          },
          {
            width: 30,
            height: 40,
            top: 58,
            left: 60,
            name: '北正镇',
            url: 'beizhengzhen'
          },
          {
            width: 46,
            height: 30,
            top: 106,
            left: 70,
            name: '八十八乡',
            url: 'bashibaxiang'
          },
          {
            top: 100,
            left: '160',
            width: '46',
            height: '40',
            name: '长岭镇',
            url: 'zhanglingzhen'
          },
          {
            top: 125,
            left: 215,
            width: '35',
            height: '20',
            name: '流水镇',
            url: 'liushuizhen'
          },
          {
            width: 26,
            height: 20,
            top: 144,
            left: 200,
            name: '海青乡',
            url: 'haiqingxiang'
          },
          {
            width: 40,
            height: 15,
            top: 167,
            left: 245,
            name: '利发盛镇',
            url: 'lifashengzhen'
          },
          {
            width: 46,
            height: 15,
            bottom: 105,
            right: 33,
            name: '太平山镇',
            url: 'taipingshanzhen'
          },
          {
            width: 46,
            height: 15,
            bottom: 86,
            right: 7,
            name: '永久镇',
            url: 'yongjiuzhen'
          },
          {
            width: 36,
            height: 20,
            top: 120,
            right: 70,
            name: '光明乡',
            url: 'guangmingxiang'
          },
          {
            width: 46,
            height: 40,
            top: 65,
            left: 100,
            name: '三团乡',
            url: 'santuanxiang'
          },
          {
            width: '26',
            height: '20',
            top: '90',
            right: '90',
            name: '集体乡',
            url: 'jitixiang'
          },
          {
            width: 36,
            height: 20,
            top: 98,
            right: 35,
            name: '三青山镇',
            url: 'sanqingshanzhen'
          },
          {
            width: 46,
            height: 20,
            top: 70,
            right: 40,
            name: '巨宝山镇',
            url: 'jubaoshanzhen'
          }
        ]
      },
      {
        bottom: '130',
        left: '50',
        width: '90',
        height: '50',
        name: '乾安县',
        areaCode: '220723',
        url: 'qiananxian',
        mapWidth: 268,
        images: 'home/gis/gis-qiananxian.png',
        positions: [
          {
            top: '88',
            right: '104',
            width: '40',
            height: '42',
            name: '乾安镇',
            url: 'qiananzhen'
          },
          {
            width: 62,
            height: 88,
            top: 65,
            right: 33,
            name: '让字镇',
            url: 'rangzizhen'
          },
          {
            width: 49,
            height: 42,
            top: 26,
            right: 93,
            name: '余字乡',
            url: 'yuzixiang'
          },
          {
            width: 36,
            height: 42,
            top: 60,
            right: 148,
            name: '水字镇',
            url: 'shuizizhen'
          },
          {
            width: 40,
            height: 62,
            top: 108,
            right: 188,
            name: '道字乡',
            url: 'daozixiang'
          },
          {
            width: 55,
            height: 30,
            top: 138,
            right: 117,
            name: '赞字乡',
            url: 'zanzixiang'
          },
          {
            width: 20,
            height: 100,
            top: 160,
            right: 168,
            name: '严字乡',
            url: 'yanzixiang'
          },
          {
            width: 110,
            height: 58,
            bottom: 32,
            right: 30,
            name: '安字镇',
            url: 'anzizhen'
          },
          {
            width: 50,
            height: 65,
            bottom: 5,
            left: 108,
            name: '所字镇',
            url: 'suozizhen'
          },
          {
            width: 43,
            height: 58,
            bottom: 60,
            left: 66,
            name: '大布苏镇',
            url: 'dabusuzhen'
          }
        ]
      },
      {
        width: 40,
        height: 50,
        top: 10,
        left: 180,
        name: '宁江区',
        areaCode: '220702',
        url: 'ningjiangqu',
        mapWidth: 199,
        images: 'home/gis/gis-ningjiangqu.png',
        positions: [
          {
            width: 40,
            height: 54,
            top: 39,
            right: 147,
            name: '大洼镇',
            url: 'dawazhen'
          },
          {
            width: 30,
            height: 65,
            top: 60,
            left: 124,
            name: '伯都乡',
            url: 'bodouxiang'
          },
          {
            width: 28,
            height: 54,
            top: 114,
            left: 86,
            name: '毛都站镇',
            url: 'maodouzhanzhen'
          },
          {
            width: 30,
            height: 64,
            bottom: 73,
            left: 130,
            name: '新城乡',
            url: 'xinchengxiang'
          },
          {
            width: 30,
            height: 58,
            bottom: 76,
            right: 150,
            name: '善友镇',
            url: 'shanyouzhen'
          },
          {
            width: 43,
            height: 43,
            bottom: 27,
            right: 94,
            name: '哈达山镇',
            url: 'hadashanzhen'
          }
        ]
      },
      {
        top: '50',
        right: '10',
        width: '90',
        height: '50',
        name: '扶余市',
        areaCode: '220781',
        url: 'fuyushi',
        mapWidth: 294,
        images: 'home/gis/gis-fuyushi.png',
        positions: [
          {
            width: 50,
            height: 37,
            top: 28,
            right: 147,
            name: '得胜镇',
            url: 'deshengzhen'
          },
          {
            width: 50,
            height: 25,
            top: 60,
            left: 100,
            name: '长春岭镇',
            url: 'changchunlingzhen'
          },
          {
            width: 56,
            height: 34,
            top: 60,
            left: 36,
            name: '三骏满族蒙古族锡伯族乡',
            url: 'sanjunmanzumengguzuxibozuxiang'
          },
          {
            width: 34,
            height: 35,
            top: 105,
            left: 46,
            name: '永平乡',
            url: 'yongpingxiang'
          },
          {
            width: 34,
            height: 35,
            top: 104,
            left: 98,
            name: '三井子镇',
            url: 'sanjingzizhen'
          },
          {
            width: 46,
            height: 20,
            top: 98,
            left: 149,
            name: '大林子镇',
            url: 'dalinzizhen'
          },
          {
            width: 34,
            height: 23,
            top: 92,
            left: 196,
            name: '更新乡',
            url: 'gengxinxiang'
          },
          {
            width: 36,
            height: 31,
            top: 135,
            left: 157,
            name: '新万发镇',
            url: 'xinwanfazhen'
          },
          {
            width: 29,
            height: 19,
            top: 131,
            left: 201,
            name: '弓棚子镇',
            url: 'gongpengzizhen'
          },
          {
            width: 45,
            height: 30,
            top: 144,
            left: 234,
            name: '肖家乡',
            url: 'xiaojiaxiang'
          },
          {
            width: 34,
            height: 35,
            top: 182,
            left: 189,
            name: '五家站镇',
            url: 'wujiazhanzhen'
          },
          {
            width: 34,
            height: 36,
            bottom: 42,
            left: 133,
            name: '新站乡',
            url: 'xinzhanxiang'
          },
          {
            width: 34,
            height: 25,
            top: 133,
            right: 35,
            name: '蔡家沟镇',
            url: 'caijiagouzhen'
          },
          {
            width: 40,
            height: 25,
            top: 173,
            right: 45,
            name: '三岔河镇',
            url: 'sanchahezhen'
          },
          {
            width: 40,
            height: 30,
            top: 202,
            right: 93,
            name: '陶赖昭镇',
            url: 'taolaizhaozhen'
          },
          {
            width: 13,
            height: 52,
            bottom: 5,
            right: 64,
            name: '新源镇',
            url: 'xinyuanzhen'
          },
          {
            left: '72',
            bottom: '43',
            width: '50',
            height: '43',
            name: '增盛镇',
            url: 'zengshengzhen'
          }
        ]
      }
    ],
    left: '80',
    top: '30',
    width: '50',
    height: '55',
    url: 'songyuanshi'
  },
  {
    name: '辽源市',
    images: 'home/gis/gis-liaoyuan.png',
    areaCode: '2204',
    mapWidth: '197',
    positions: [
      {
        top: 10,
        left: 100,
        width: '70',
        height: '50',
        areaCode: '220422',
        mapWidth: 230,
        name: '东辽县',
        url: 'dongliaoxian',
        images: 'home/gis/dongliaoxian.png',
        positions: [
          {
            width: 30,
            height: 50,
            bottom: 30,
            left: 120,
            name: '安恕镇',
            url: 'anshuzhen'
          },
          {
            width: 30,
            height: 50,
            bottom: 30,
            left: 160,
            name: '凌云乡',
            url: 'lingyunxiang'
          },
          {
            width: 30,
            height: 50,
            bottom: 50,
            left: 200,
            name: '渭津镇',
            url: 'weijinzhen'
          },
          {
            width: 50,
            height: 50,
            bottom: 100,
            left: 230,
            name: '辽河源镇',
            url: 'liaoheyuanzhen'
          },
          {
            width: 30,
            height: 50,
            bottom: 160,
            left: 220,
            name: '安石镇',
            url: 'anshizhen'
          },
          {
            width: 30,
            height: 30,
            top: 40,
            left: 190,
            name: '金州乡',
            url: 'jinzhouxiang'
          },
          {
            width: 40,
            height: 30,
            top: 50,
            left: 130,
            name: '建安镇',
            url: 'jiananzhen'
          },
          {
            width: 40,
            height: 30,
            top: 10,
            left: 150,
            name: '足民乡',
            url: 'zuminxiang'
          },
          {
            width: 40,
            height: 30,
            top: 10,
            left: 150,
            name: '足民乡',
            url: 'zuminxiang'
          },
          {
            width: 40,
            height: 30,
            top: 20,
            left: 90,
            name: '甲山乡',
            url: 'jiashanxiang'
          },
          {
            width: 40,
            height: 30,
            top: 60,
            left: 70,
            name: '云顶镇',
            url: 'yundingzhen'
          },
          {
            width: 40,
            height: 30,
            top: 100,
            left: 70,
            name: '泉太镇',
            url: 'quantaizhen'
          },
          {
            width: 40,
            height: 30,
            top: 150,
            left: 70,
            name: '平岗镇',
            url: 'pinggangzhen'
          },
          {
            width: 30,
            height: 30,
            top: 120,
            left: 110,
            name: '白泉镇',
            url: 'baiquanzhen'
          }
        ]
      }
    ],
    width: 20,
    height: 55,
    top: 140,
    left: 140,
    url: 'liaoyuanshi'
  },
  {
    name: '通化市',
    images: 'home/gis/tonghuashi.png',
    areaCode: '2205',
    mapWidth: '133',
    width: 20,
    height: 55,
    top: 180,
    left: 170,
    url: 'tonghuashi',
    positions: [
      {
        width: 30,
        height: 50,
        top: 40,
        left: 200,
        areaCode: '220523',
        mapWidth: 270,
        name: '辉南县',
        url: 'huinanxian',
        images: 'home/gis/huinanxian.png',
        positions: [
          {
            width: 30,
            height: 30,
            top: 130,
            left: 80,
            name: '楼街朝鲜族乡',
            url: 'loujiechaoxianzuxiang'
          },
          {
            width: 30,
            height: 30,
            top: 200,
            left: 110,
            name: '样子哨镇',
            url: 'yangzishaozhen'
          },
          {
            width: 30,
            height: 30,
            top: 210,
            left: 180,
            name: '金川镇',
            url: 'jinchuanzhen'
          },
          {
            width: 30,
            height: 30,
            top: 150,
            left: 190,
            name: '抚民镇',
            url: 'fuminzhen'
          },
          {
            width: 30,
            height: 30,
            top: 150,
            left: 120,
            name: '杉松岗镇',
            url: 'shansonggangzhen'
          },
          {
            width: 30,
            height: 30,
            top: 90,
            left: 120,
            name: '辉南镇',
            url: 'huinanzhen'
          },
          {
            width: 30,
            height: 30,
            top: 60,
            left: 170,
            name: '庆阳镇',
            url: 'qingyangzhen'
          },
          {
            width: 30,
            height: 30,
            top: 70,
            left: 70,
            name: '朝阳镇',
            url: 'chaoyangzhen'
          },
          {
            width: 30,
            height: 30,
            top: 10,
            left: 80,
            name: '团林镇',
            url: 'tuanlinzhen'
          },
          {
            width: 30,
            height: 30,
            top: 10,
            left: 140,
            name: '辉发城镇',
            url: 'huifachengzhen'
          },
          {
            width: 60,
            height: 30,
            top: 90,
            left: 220,
            name: '石道河镇',
            url: 'shidaohezhen'
          }
        ]
      },
      {
        width: 50,
        height: 50,
        top: 30,
        left: 130,
        areaCode: '220581',
        mapWidth: 168,
        name: '梅河口市',
        url: 'meihekoushi',
        images: 'home/gis/meihekoushi.png',
        positions: [
          {
            width: 30,
            height: 10,
            top: 25,
            left: 190,
            name: '康大营镇',
            url: 'kangdayingzhen'
          },
          {
            width: 30,
            height: 10,
            top: 45,
            left: 210,
            name: '兴华镇',
            url: 'xinghuazhen'
          },
          {
            width: 30,
            height: 10,
            top: 65,
            left: 190,
            name: '一座营镇',
            url: 'yizuoyingzhen'
          },
          {
            width: 30,
            height: 10,
            top: 95,
            left: 190,
            name: '双兴镇',
            url: 'shuangxingzhen'
          },
          {
            width: 30,
            height: 10,
            top: 90,
            left: 220,
            name: '牛心顶镇',
            url: 'niuxindingzhen'
          },
          {
            width: 30,
            height: 10,
            top: 120,
            left: 210,
            name: '海龙镇',
            url: 'hailongzhen'
          },
          {
            width: 30,
            height: 10,
            top: 140,
            left: 230,
            name: '新合镇',
            url: 'xinhezhen'
          },
          {
            width: 30,
            height: 10,
            top: 140,
            left: 190,
            name: '李炉乡',
            url: 'liluxiang'
          },
          {
            width: 30,
            height: 10,
            top: 160,
            left: 200,
            name: '兴岭镇',
            url: 'xinglingzhen'
          },
          {
            width: 30,
            height: 10,
            top: 185,
            left: 190,
            name: '进化镇',
            url: 'jinhuazhen'
          },
          {
            width: 30,
            height: 10,
            top: 195,
            left: 160,
            name: '红梅镇',
            url: 'hongmeizhen'
          },
          {
            width: 30,
            height: 10,
            top: 195,
            left: 160,
            name: '红梅镇',
            url: 'hongmeizhen'
          },
          {
            width: 30,
            height: 10,
            top: 175,
            left: 170,
            name: '曙光镇',
            url: 'shuguangzhen'
          },
          {
            width: 30,
            height: 10,
            top: 165,
            left: 150,
            name: '黑山头镇',
            url: 'heishantouzhen'
          },
          {
            width: 30,
            height: 10,
            top: 115,
            left: 180,
            name: '湾龙镇',
            url: 'wanlongzhen'
          },
          {
            width: 30,
            height: 10,
            top: 215,
            left: 140,
            name: '水道镇',
            url: 'shuidaozhen'
          },
          {
            width: 30,
            height: 10,
            top: 225,
            left: 130,
            name: '吉乐乡',
            url: 'jilexiang'
          },
          {
            width: 30,
            height: 10,
            top: 185,
            left: 140,
            name: '中和镇',
            url: 'zhonghezhen'
          },
          {
            width: 30,
            height: 10,
            top: 195,
            left: 110,
            name: '山城镇',
            url: 'shanchengzhen'
          },
          {
            width: 30,
            height: 10,
            bottom: 20,
            left: 100,
            name: '小羊乡',
            url: 'xiaoyangxiang'
          }
        ]
      }
    ]
  }
];
